import Modal from '../ui/Modal';
import { useState } from 'react';
import { createVenue, updateVenue, deleteVenue, setVenueEquipment, uploadVenueImage, setAppSetting } from '../lib/supabase';
import VenueCard from '../ui/VenueCard';
import VenueEditModal from '../modals/VenueEditModal';

function VenuesList({ venues, venueEquipment, currentUser, onRefresh, defaultVenueBg }) {
  const [editTarget,setEditTarget]=useState(null);
  const [confirmDelete,setConfirmDelete]=useState(null);
  const [uploadingDefault,setUploadingDefault]=useState(false);
  const [uploadError,setUploadError]=useState("");
  const isAdmin=currentUser.is_admin;
  const isVenueUser=currentUser.accountType==="venue";

  const handleDefaultBgUpload=async(e)=>{
    const file=e.target.files?.[0];if(!file)return;
    setUploadingDefault(true);setUploadError("");
    try{
      const url=await uploadVenueImage(file);
      await setAppSetting('default_venue_bg',url);
      onRefresh();
    }catch{setUploadError("Errore nel caricamento. Riprova.");}
    finally{setUploadingDefault(false);}
  };
  const handleRemoveDefaultBg=async()=>{
    await setAppSetting('default_venue_bg',null);
    onRefresh();
  };

  return (
    <div className="fade-up">
      <div style={{marginBottom:24,textAlign:"center"}}>
        <div style={{fontSize:26,fontWeight:800,color:"var(--text)",lineHeight:1.1}}>Locations</div>
        <div style={{fontSize:16,color:"var(--muted)",marginTop:6}}>{venues.length} spazi registrati</div>
      </div>
      {isAdmin&&<div style={{textAlign:"center",marginBottom:16}}>
        <button className="btn btn-primary btn-sm" onClick={()=>setEditTarget({name:"",email:"",city:"",address:"",description:"",_equipment:[]})}>+ Aggiungi location</button>
      </div>}

      {/* ── SFONDO DI DEFAULT (solo admin) ── */}
      {isAdmin&&(
        <div style={{marginBottom:20,padding:"16px 18px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:16}}>
          <div style={{fontWeight:700,fontSize:17,color:"var(--text)",marginBottom:4}}>Sfondo di default</div>
          <div style={{fontSize:16,color:"var(--muted)",marginBottom:12,lineHeight:1.6}}>
            Immagine usata come sfondo nelle card evento per tutte le location senza una foto propria.
          </div>
          {defaultVenueBg&&(
            <div style={{position:"relative",marginBottom:12}}>
              <img src={defaultVenueBg} alt="Sfondo default" style={{width:"100%",height:120,objectFit:"cover",borderRadius:10,display:"block"}}/>
              <div style={{position:"absolute",inset:0,background:"rgba(24,22,20,0.4)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <span style={{fontSize:16,color:"#fff",fontWeight:600}}>Sfondo attuale</span>
              </div>
            </div>
          )}
          {uploadError&&<div style={{fontSize:16,color:"var(--danger)",marginBottom:8}}>{uploadError}</div>}
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"8px 14px",borderRadius:10,border:"1px dashed rgba(237,77,29,0.3)",background:"rgba(237,77,29,0.04)"}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              <span style={{fontSize:16,color:"var(--muted)",fontWeight:600}}>{uploadingDefault?"Caricamento...":(defaultVenueBg?"Cambia immagine":"Carica immagine (JPG/PNG)")}</span>
              <input type="file" accept="image/jpeg,image/png" style={{display:"none"}} onChange={handleDefaultBgUpload} disabled={uploadingDefault}/>
            </label>
            {defaultVenueBg&&(
              <button onClick={handleRemoveDefaultBg}
                style={{fontSize:16,padding:"8px 14px",borderRadius:10,border:"1px solid rgba(255,82,82,0.25)",background:"rgba(255,82,82,0.04)",color:"#FF5252",cursor:"pointer",fontWeight:600}}>
                ✕ Rimuovi
              </button>
            )}
          </div>
        </div>
      )}

      {venues.length===0&&<div className="empty-state"><div>Nessuna location ancora.</div></div>}

      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {venues.map(v=>{
          const eq=venueEquipment[v.id]||[];
          const canEdit=isAdmin||(isVenueUser&&currentUser.id===v.id);
          return <VenueCard key={v.id} v={v} eq={eq} canEdit={canEdit} isAdmin={isAdmin}
            onEdit={()=>setEditTarget({...v,_equipment:eq})}
            onDelete={()=>setConfirmDelete(v)}/>;
        })}
      </div>

      {editTarget&&<VenueEditModal venue={editTarget} title={editTarget.id?"Modifica location":"Nuova location"} onClose={()=>setEditTarget(null)}
        onSave={async(data,equipment)=>{
          let v;
          if(editTarget.id) v=await updateVenue(editTarget.id,data);
          else v=await createVenue(data);
          await setVenueEquipment(v.id,equipment.map(item=>({item})));
          onRefresh();setEditTarget(null);
        }}/>}

      {confirmDelete&&<Modal onClose={()=>setConfirmDelete(null)}>
        <div className="modal-title">Elimina location</div>
        <div style={{marginBottom:16,fontSize:16,color:"var(--muted)"}}>Eliminare <strong style={{color:"var(--text)"}}>{confirmDelete.name}</strong>?</div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={()=>setConfirmDelete(null)}>Annulla</button>
          <button className="btn btn-danger" onClick={async()=>{await deleteVenue(confirmDelete.id);setConfirmDelete(null);onRefresh();}}>Sì, elimina</button>
        </div>
      </Modal>}
    </div>
  );
}

export default VenuesList;
